export enum Brands {
    Scania = 'Scania',
    ScaniaCn = 'ScaniaCn',
    International = 'International',
    Man = 'Man'
}
